export default `
<span class="{{class}} badge">
  {{value}}
</span>

`;
